var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('prepare-document',{class:{
    'layout-blur': _vm.$q.screen.lt.sm
  },attrs:{"uuid":_vm.uuid,"assistant":_vm.assistant}})}
var staticRenderFns = []

export { render, staticRenderFns }